import { Box } from '@rbilabs/universal-components';

import { ProductWizardStep } from 'pages/menu/components/product-wizard/types';
import { primitive } from 'styles/constants/primitives';

export const MOBILE_SAFETY_MEASURE = '100px';

export const PRODUCT_IMAGE_HEIGHT_MOBILE = '300px';
export const PRODUCT_IMAGE_HEIGHT_DESKTOP = '350px';

export const DEFAULT_PRODUCT_CARD_HEIGHT_MOBILE = 170;
export const DEFAULT_PRODUCT_CARD_HEIGHT_DESKTOP = 190;

export const FADE_IN_ANIMATION_MILLIS = 700;

export const SelectorContainer = Box.withConfig({
  width: 'full',
  backgroundColor: primitive.$white,
});

export interface SelectorItemProps {
  selected: boolean;
}

export const productDetailFlowContainerStyles: any = {
  flex: 1,
  width: '100%',
};

export const ProductDetailFlowContent = Box.withConfig({
  flex: 1,
  width: 'full',
});

export const getBackgroundColorByStep = (step: ProductWizardStep) =>
  step === ProductWizardStep.ProductHome || step === ProductWizardStep.PickerReview
    ? Styles.color.white
    : primitive.$white;
